import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmployeeService } from '@shared/services/mesuser.service';
import { ProductionDataService } from '@shared/services/production-data.service';
import { ProductionTerminalService } from '@shared/services/production-terminal.service';
import { ScannerListenerService } from '@shared/services/scanner-listener.service';
import { ITerminal } from '@shared/services/terminalAdministration.service';
import { ActiveWorkflowService } from '../../shared/services/active-workflow.service';

@Component({
	selector: 'app-mes-production-terminal',
	templateUrl: './mes-production-terminal.component.html',
	styleUrls: ['./mes-production-terminal.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MesProductionTerminalComponent implements OnInit {
	public dialogMessage: string | null = null;
	public dialogIsError: boolean = false;
	public isArriveLeaveTerminal = true;
	protected showNonReady: boolean = false;

	constructor(
		public employeeService: EmployeeService,
		public terminalData: ProductionDataService,
		public terminalService: ProductionTerminalService,
		scannerListenerService: ScannerListenerService,
		private route: ActivatedRoute,
		private activeWorkFlowService: ActiveWorkflowService,
	) {
		scannerListenerService.context.push([ScannerListenerService.scannerPrefixes.employeePrefix, ScannerListenerService.scannerPrefixes.worktaskPrefix, ScannerListenerService.scannerPrefixes.groupPrefix, ScannerListenerService.scannerPrefixes.itemPrefix]);

		this.terminalService.onTerminalChanged().subscribe((terminal) => {
			this.activeWorkFlowService.updateWorkFlowServiceType(terminal);
			this.isArriveLeaveTerminal = !this.hasConfiguredSql(terminal);
		});
	}

	ngOnInit(): void {
		this.route.params.subscribe((params) => {
			const newTerminalId = params['terminalId'];
			this.terminalService.setTerminalId(newTerminalId);
		});
	}

	onShowNonReadyChange(value: boolean) {
		this.showNonReady = value;
	}

	private hasConfiguredSql(terminal: ITerminal | null | undefined): boolean {
		return Boolean(terminal?.sqlQuery?.trim());
	}
}
